<template>
  <div class="home">
    <div class="homeTopContent">
      <div class="block">
        <el-carousel indicator-position="none">
          <el-carousel-item
            v-for="(item, index) in bannerImgList"
            trigger="click"
            :key="index"
          >
            <div class="imgBannerBox" @click="toBanner(item)">
              <img :src="item.coverUrl" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="advtop" v-if="advTopImgList.length > 0">
        <ul class="clearfix">
          <li v-for="(item, index) in advTopImgList" :key="index">
            <a v-if="index < 3" @click="toBanner(item)">
              <img :src="item.coverUrl" alt="" />
            </a>
          </li>
        </ul>
      </div>
      <div class="nav" id="nav">
        <ul class="el-menu-demo el-menu--horizontal el-menu">
          <li
            class="el-menu-item"
            :class="activeIndex == item.Id ? 'is-active' : ''"
            v-for="(item, index) in navList"
            :key="index"
          >
            <a href="javascript:;" @click="handleSelect(item.Id)">
              {{ item.Title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- 作品列表 -->
    <div class="homeContent" v-loading="loading">
      <div class="workList" id="workList">
        <ul class="clearfix" v-if="workListData.length != 0">
          <li
            v-for="(item, index) in workListData" 
            :key="index"
            :class="(index + 1) % 5 == 0 ? 'noMargin' : ''"
          >
            <div>
              <a target="_blank" @click="toDetail(item.id, item.title)">
                <div
                  class="imgWork"
                  @mouseenter="selectStyle(index, $event)"
                  @mouseleave="outStyle(index, $event)"
                >
                  <img v-if="item.coverUrl" :src="item.coverUrl" alt="" />
                  <img v-if="!item.coverUrl" src="../assets/img/faultImg.png" />
                  <div class="mask" v-if="item.maskflag"></div>
                </div>
              </a>

              <div class="contentWork">
                <a
                  class="title"
                  target="_blank"
                  @click="toDetail(item.id, item.title)"
                  >{{ item.title }}</a
                >

                <p class="statistical">
                  <span class="typeWork">
                    <em v-if="item.copyright == 0">原创</em>
                    <em v-if="item.copyright == 1">转载</em>
                  </span>
                  <span class="browseNumber">
                    <i class="iconfont iconliulanliang"></i>
                    <em>{{ item.viewNum }}</em>
                  </span>
                  <span class="browseNumber">
                    <i class="iconfont iconzan"></i>
                    <em>{{ item.favourNum }}</em>
                  </span>
                </p>
                <p
                  class="authorInfo"
                  v-if="item.userInfo"
                  @click="gousercenter(item.userInfo.id)"
                >
                  <img
                    v-if="item.userInfo.avatarUrl != null"
                    :src="item.userInfo.avatarUrl"
                    alt=""
                  />
                  <img v-else src="../assets/img/fault.png" alt="" />
                  <a target="_blank">{{ item.userInfo.nickName }}</a>
                </p>
              </div>
            </div>
          </li>
        </ul>
        <div class="pagination">
          <el-pagination
            background
            @current-change="currentPage"
            layout="prev, pager, next"
            :current-page="worksParam.pageNum"
            :page-size="worksParam.pageSize"
            :total="totalSumCountRulesList"
            v-if="totalSumCountRulesList > 2"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 精品推荐 -->
    <div class="advLinkBox" v-if="advBottomImgList.length != 0">
      <p class="advLinkTitle">精品推荐</p>
      <ul class="clearfix">
        <li
          v-for="(item, index) in advBottomImgList"
          :key="index"
          :class="index % 3 == 2 ? 'noMargin' : ''"
        >
          <div @click="toBanner(item)">
            <div class="imgWork">
              <img :src="item.coverUrl" alt="" />
              <!-- <img
                :src="item.coverUrl"
                alt=""
                v-if="item.coverUrl"
              /> -->
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- 设计师列表 -->
    <div class="designerList" v-if="designerListData.length > 0">
      <p class="designerTitle">与20000+设计师一起成长</p>
      <div class="borderLineBox">
        <span class="borderLine"></span>
      </div>
      <ul class="clearfix">
        <li
          v-for="(item, index) in designerListData"
          :key="index"
          :class="index % 8 == 7 ? 'noMargin' : ''"
        >
          <a href="javascript:;">
            <div>
              <div class="imgWork">
                <img :src="item.avatarUrl" alt="" />
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from "@/utils/request.js";
export default {
  name: "home",
  data() {
    return {
      loadinghome: false,
      navList: [
        {
          Title: "热门推荐",
          Id: "-1",
        },
        {
          Title: "作品",
          Id: "0",
        },
        {
          Title: "经验分享",
          Id: "1",
        },
      ],
      homeFlag: false,
      loading: false,
      accessKeyId: "",
      accessKeySecret: "",
      stsToken: "",
      endpoint: "",
      bucket: "",
      totalSumCountRulesList: 0,
      // listDataParame: {
      //   LablesId: 0,
      //   model: {
      //     CopyrightType: "-1", //0 原创 1 转载 ，全部传-1【包model】
      //     TextType: "-1" //0 作品 1 文章
      //   },
      //   QueryStr: "", //通用搜索，按照作品名称，用户昵称
      //   OrderByType: 2, //0 默认倒叙 1 正序 2 浏览量
      //   VisitType: 1, //1 官网访问  2 官网后台访问
      //   Paging: {
      //     PageIndex: 1,
      //     PageSize: 20
      //   }
      // },
      worksParam: {
        pageNum: 1,
        pageSize: 20,
        isArticle: null,
        isBlock: false,
        isHot: true,
        isPass: true,
      },
      workListData: [],
      designerListData: [],
      activeIndex: "-1",
      bannerImgList: [],
      advTopImgList: [],
      advBottomImgList: [],
      advRightImgList: [],
      timer: null,
    };
  },
  watch: {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  mounted: function () {
    this.loading = true;
    window.self = this;
    let height = parseFloat($(window).height()) - 288.33;
    $(".workList").css("min-height", height);
    // this.listDataParame.Paging.PageIndex = 1;
    //this.getListData(this.listDataParame);
    // this.getAllImgList();
    this.getBannerworksList();
    this.getTopworksList();

    // this.getHotRecommendedWorksList();
    this.getWorksList(this.worksParam);
    this.getProductsRecommendedworksList();
    this.getDesignerList();
    // this.fetchSourceData()
    //   .then(res => {
    //     this.listDataParame.Paging.PageIndex = 1;
    //     this.getListData(this.listDataParame);
    //     this.getAllImgList();
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
    // window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    // window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    gousercenter(UserId, e) {
      if (e) {
        e.stopPropagation();
      }

      var tempwindow = window.open("_blank");
      let Url =
        (location.origin.indexOf(":") != -1
          ? location.origin + ""
          : location.origin) +
        "/design/usercenter?usercenterFWUserId=" +
        UserId;
      // let Url = "http://www.tuuux.com/design/usercenter?usercenterFWUserId=" + UserId;
      // location.origin

      tempwindow.location = Url;
    },
    toDetail(id, title) {
      let info = this.info;
      let routeUrl = this.$router.resolve({
        path: "/design/worksdetail",
        query: {
          id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    selectStyle(index, e) {
      e.stopPropagation();
      // console.log("进来");
      this.workListData[index].maskflag = true;
      this.$forceUpdate();
    },
    outStyle(index, e) {
      e.stopPropagation();
      // console.log("出去");
      this.workListData[index].maskflag = false;
      this.$forceUpdate();
    },
    // getOssToken() {
    //   this.$axios({
    //     method: "post",
    //     url: "/api/OSS/OwGetToken",
    //     data: { data: 0 }
    //   })
    //     .then(success => {
    //       if (success.State == 1) {
    //         console.log("111");
    //         this.accessKeyId = success.Data.AccessKeyId;
    //         this.accessKeySecret = success.Data.AccessKeySecret;
    //         this.stsToken = success.Data.SecurityToken;
    //         this.endpoint = success.Data.Endpoint;
    //         this.bucket = success.Data.Bucket;
    //         this.$storage.set("PCAccessKeyId", success.Data.AccessKeyId);
    //         this.$storage.set(
    //           "PCAccessKeySecret",
    //           success.Data.AccessKeySecret
    //         );
    //         this.$storage.set("PCStsToken", success.Data.SecurityToken);
    //         this.$storage.set("PCEndpoint", success.Data.Endpoint);
    //         this.$storage.set("PCBucket", success.Data.Bucket);
    //         return;
    //       }
    //       this.thenFn(success.State, success.Msg);
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    // fetchSourceData(callback) {
    //   return new Promise((resolve, reject) => {
    //     resolve(this.getOssToken());
    //   });
    // },
    // goactivitydetail(type, Content) {
    //   // 0 文案 1 超链接
    //   let Url = "";
    //   var tempwindow = window.open("_blank");
    //   if (type == 0) {
    //     this.$storage.set("ActivityContent", Content);
    //     Url = "http://www.tuuux.com/design/activitydetail";
    //   } else {
    //     Url = Content;
    //     if (Url.indexOf("http://") < 0) {
    //       Url = "http://" + Url;
    //     }
    //   }
    //   tempwindow.location = Url;
    // },
    // gousercenter(UserId, e) {
    //   if (e) {
    //     e.stopPropagation();
    //   }

    //   var tempwindow = window.open("_blank");
    //   let Url =
    //     "http://www.tuuux.com/design/usercenter?usercenterFWUserId=" + UserId;
    //   tempwindow.location = Url;
    // },

    // getAllImgList() {
    //   this.$axios({
    //     method: "post",
    //     url: "/api/OwIndex/GetOwIndexList", //
    //     data: {}
    //   })
    //     .then(response => {
    //       if (response.State == "1") {
    //         // SetUpType 字段来区分类型：类型  0 首页Banner 1 首页顶部广告  2 首页底部广告 3 侧边广告
    //         this.designerListData = [];
    //         response.Data.UserList.forEach(item => {
    //           if (item.IsViewIndex == 1) {
    //             this.designerListData.push(item);
    //           }
    //         });

    //         response.Data.OwSyssetupList.forEach(item => {
    //           if (item.SetUpType == 0) {
    //             // let obj = {
    //             //   CoverUrl: item.CoverUrl
    //             // };
    //             this.bannerImgList.push(item);
    //           }
    //           if (item.SetUpType == 1) {
    //             // let obj = {
    //             //   CoverUrl: item.CoverUrl
    //             // };
    //             this.advTopImgList.push(item);
    //           }
    //           if (item.SetUpType == 2) {
    //             // let obj = {
    //             //   CoverUrl: item.CoverUrl
    //             // };
    //             this.advBottomImgList.push(item);
    //           }
    //           if (item.SetUpType == 3) {
    //             // let obj = {
    //             //   CoverUrl: item.CoverUrl
    //             // };
    //             this.advRightImgList.push(item);
    //           }
    //         });
    //         this.loadinghome = false;
    //       } else {
    //         this.$message({
    //           message: response.Msg,
    //           type: "warning",
    //           customClass: "alertStyle",
    //           duration: "1500"
    //         });
    //       }
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    // goWorkDetail(Id, TextType) {
    //   var tempwindow = window.open("_blank"); //打开一个窗口，然后用
    //   let Url = "";
    //   if (TextType == 0) {
    //     Url = "http://www.tuuux.com/design/worksdetail?Id=" + Id;
    //   } else {
    //     Url = "http://www.tuuux.com/design/articledetail?Id=" + Id;
    //   }
    //   tempwindow.location = Url;
    // },
    currentPage: function (val) {
      this.loading = true;
      this.workListData = [];
      this.worksParam.pageNum = val;
      this.getWorksList(this.worksParam);
      document.getElementById("nav").scrollIntoView();
    },
    /*获取图片用来展示*/
    // showImgsBanner(toreAs) {
    //   var client = new OSS({
    //     accessKeyId: "LTAI4G8rTA42W2kZ6zqDyXLg",
    //     accessKeySecret: "fSeo35j8mqDWtL1bP4OYaF7ofCtWke",
    //     // stsToken: this.stsToken,
    //     endpoint: this.endpoint,
    //     bucket: this.bucket
    //   });
    //   var signUrl = client.signatureUrl(toreAs, {
    //     expires: 600
    //   });
    //   return signUrl;
    // },
    // showImgs(toreAs) {
    //   var client = new OSS({
    //     accessKeyId: this.accessKeyId,
    //     accessKeySecret: this.accessKeySecret,
    //     stsToken: this.stsToken,
    //     endpoint: this.endpoint,
    //     bucket: this.bucket
    //   });
    //   var signUrl = client.signatureUrl(toreAs, {
    //     expires: 600,
    //     process:
    //       "image/resize,w_316,h_200/auto-orient,1/quality,q_90/format,src"
    //   });
    //   return signUrl;
    // },
    // getListData(parame) {
    //   this.$axios({
    //     method: "post",
    //     url: "/api/OwArticlesandworks/GetOwArticlesandworksList", //
    //     data: parame
    //   })
    //     .then(response => {
    //       if (response.State == "1") {
    //         // response.Data.Artlist.forEach(item => {
    //         //   item.maskflag = false;
    //         //   this.workListData.push(item);
    //         // });
    //         this.workListData = response.Data.Artlist;
    //         // console.log(this.workListData);
    //         this.workListData.forEach(item => {
    //           item.maskflag = false;
    //         });
    //         this.totalSumCountRulesList = response.Data.Count;
    //         this.loading = false;
    //         this.$nextTick(() => {
    //           this.homeFlag = true;
    //         });
    //       } else {
    //         this.$message({
    //           message: response.Msg,
    //           type: "warning",
    //           customClass: "alertStyle",
    //           duration: "1500"
    //         });
    //       }
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    handleSelect(key) {
      // this.totalSumCountRulesList = 0;
      // this.workListData = [];
      this.loading = true;
      this.activeIndex = key;
      this.worksParam.pageNum = 1;
      if (key === "-1") {
        this.worksParam.isArticle = null;
        this.worksParam.isHot = true;
      } else if (key === "0") {
        // this.getAllWorksList();
        this.worksParam.isArticle = true;
        this.worksParam.isHot = false;
      } else {
        this.worksParam.isArticle = false;
        this.worksParam.isHot = false;
      }

      this.getWorksList(this.worksParam);
      // this.getHotRecommendedWorksList(this.worksParam);

      // this.listDataParame.model.TextType = key;
      // if (key == -1) {
      //   this.listDataParame.OrderByType = 2;
      // } else {
      //   this.listDataParame.OrderByType = 0;
      // }
      // this.listDataParame.Paging.PageIndex = 1;
      // this.getListData(this.listDataParame);
    },
    goTop(e) {
      document.getElementById("nav").scrollIntoView();
    },
    scrollToTop(el) {
      let topBtn = document.getElementById("to-top-btn");
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let browserHeight = window.outerHeight;

      if (scrollTop > browserHeight) {
        topBtn.style.display = "block";
      } else {
        topBtn.style.display = "none";
      }
    },

    //获取首页banner列表
    getBannerworksList() {
      let that = this;
      api({
        method: "get",
        url: "/api/banner/list",
        params: {
          location: 0,
          type: 0,
          pageNum: 1,
          pageSize: 10,
        },
      }).then((response) => {
        that.bannerImgList = response.data.list;
        that.loading = false;
      });
    },

    //获取置顶作品
    getTopworksList() {
      let that = this;
      api({
        method: "get",
        url: "/api/banner/list",
        params: {
          location: 2,
          pageNum: 1,
          pageSize: 3,
          type: 0,
        },
      }).then((response) => {
        that.advTopImgList = response.data.list;
        that.loading = false;
      });
    },
    getWorksList(param) {
      let that = this;
      api({
        method: "get",
        url: "/api/product/page",
        params: param,
      })
        .then((response) => {
          that.workListData = response.data.list;
          that.totalSumCountRulesList = response.data.total;
          that.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取精品推荐列表
    getProductsRecommendedworksList() {
      let that = this;
      api({
        method: "get",
        url: "/api/banner/list",
        params: {
          location: 1,
          pageNum: 1,
          pageSize: 3,
          type: 0,
        },
      }).then((response) => {
        that.advBottomImgList = response.data.list;
      });
    },
    getDesignerList() {
      let that = this;
      api({
        method: "get",
        url: "/api/product/designer/list",
      }).then((response) => {
        that.designerListData = response.data.slice(0, 24);
        that.loading = false;
      });
    },
    toBanner(item) {
      if (item.linkUrl != "") {
        window.open(item.linkUrl, "_blank");
        // window.location.href = item.linkUrl
      } else if (item.content != "") {
        localStorage.setItem("bannerContent", item.content);
        let routeUrl = this.$router.resolve({
          path: "/design/activitydetail",
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>
<style lang="less">
.home {
  .el-loading-mask {
    background: none;
  }
}
.el-carousel__arrow {
  background: rgba(0, 0, 0, 0.3) !important;
  i {
    font-weight: bold !important;
  }
}
@media (min-width: 1600px) {
  .home {
    .el-carousel {
      border-radius: 4px;
    }
    .el-carousel__container {
      height: 350px;
      /* height: 100% !important; */
      border-radius: 4px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #3a6cf1 !important;
    }
    .el-pagination.is-background .el-pager li,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .btn-next {
      background: #fbfcfe;
      border: 1px solid #e1e5eb;
    }
    .el-pagination button,
    .el-pager li {
      height: 32px !important;
      line-height: 32px !important;
      min-width: 32px !important;
      margin: 0 5px !important;
    }
    .el-pagination .el-pager .more::before {
      line-height: 32px;
    }
    .el-pagination {
      display: inline-block;
    }
  }
}

@media screen and (max-width: 1600px) {
  .home {
    .el-carousel {
      border-radius: 4px;
    }
    .el-carousel__container {
      height: 286px;
      /* height: 100% !important; */
      border-radius: 4px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #3a6cf1 !important;
    }
    .el-pagination.is-background .el-pager li,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .btn-next {
      background: #fbfcfe;
      border: 1px solid #e1e5eb;
    }
    .el-pagination button,
    .el-pager li {
      height: 27px !important;
      line-height: 27px !important;
      min-width: 27px !important;
      margin: 0 7px !important;
    }
    .el-pagination .el-pager .more::before {
      line-height: 27px;
    }
    .el-pagination {
      display: inline-block;
    }
  }
}
</style>
<style lang="less" scoped>
@media (min-width: 1600px) {
  // .goTop {
  //   position: fixed;
  //   display: inline-block;
  //   width: 48px;
  //   height: 48px;
  //   text-align: center;
  //   line-height: 48px;
  //   color: #fff;
  //   right: 0;
  //   bottom: 75px;
  //   cursor: pointer;
  //   background: rgba(0, 0, 0, 0.3);
  //   box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
  //   border-radius: 2px;
  //   i {
  //     font-size: 26px;
  //     // font-weight: bold;
  //   }
  // }
  .home {
    .homeTopContent {
      margin: 0 auto;
      background: #fff;
      // padding: 0 30px;
      /*	box-shadow: 0 4px 10px 0 rgba(0,0,0,0.09);*/
    }
    .block {
      // margin-top: 5px;
      border-radius: 4px;
      max-width: 1380px;
      margin: 0 auto;
      padding-top: 20px;
      // height: 350pxpx;
      a {
        display: block;
      }
      .imgBannerBox {
        border-radius: 4px;
        width: 100%;
        height: 350px;
        // padding-bottom: 23.33%;
        overflow: hidden;
        transition: 0.1s linear;
        margin: 0;
        position: relative;
        /*height: 280px;
			background-repeat: no-repeat;
			background-size: 100%;*/

        img {
          position: absolute;
          transition: 0.1s linear;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    .advtop {
      // width: 1200px;
      max-width: 1380px;
      margin: 0 auto;
      background: #fff;
      padding-top: 20px;
      margin-bottom: 28px;
      /*box-shadow: 0 2px 10px 0 rgba(145,145,145,0.10);*/
      ul {
        box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
        li {
          float: left;
          width: 33.3%;
          /* border: 1px solid #E1E6F0;*/
          transition: 0.1s linear;
          height: 0px;
          padding-bottom: 14.1525%;
          overflow: hidden;
          margin: 0;
          position: relative;
          img {
            /*    	height: 170px;
    	width:100%;*/
            position: absolute;
            transition: 0.1s linear;

            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
        a {
          width: 100%;
          height: 100%;
        }
      }
    }
    .nav {
      text-align: center;
      ul {
        display: inline-block;
        margin-bottom: -4px;
      }
      .el-menu-item:hover {
        a {
          color: #374567 !important;
          font-weight: bold;
        }
      }
      .el-menu-item {
        padding: 0px;
        margin-right: 64px;
      }
      .el-menu-item:nth-of-type(3) {
        margin-right: 0px;
      }
      .el-menu.el-menu--horizontal {
        border-bottom: 0px;
        .el-menu-item.is-active {
          border-bottom: 4px solid #3d65f4;
          a {
            font-size: 18px;
            color: #374567;
            font-weight: bold;
          }
        }
        .el-menu-item {
          a {
            font-size: 18px;
            // font-weight: bold;
          }
        }
      }

      .el-menu--horizontal > .el-menu-item {
        height: 54px;
        line-height: 54px;
        a {
          color: #9fb0bd;
        }
      }
    }
    .workList {
      max-width: 1380px;
      margin: 0 auto;
      position: relative;

      .pagination {
        margin-top: 15px;
        margin-bottom: 40px;
        text-align: center;
        height: 32px;
        line-height: 32px;
        .totalNumber {
          font-size: 14px;
          color: #999999;
          margin-left: 20px;
          em {
            font-weight: bold;
            color: #202020;
          }
        }
      }
      ul {
        padding-top: 28px;

        li {
          background: #fff;
          box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
          border-radius: 4px;
          margin-bottom: 20px;
          float: left;
          width: 260px;
          margin-right: 20px;
          cursor: pointer;
          div {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
          }
          a {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }
        li.noMargin {
          margin-right: 0px;
        }
      }
      .imgWork {
        width: 100%;
        height: 0px;
        padding-bottom: 75%;
        overflow: hidden;
        margin: 0;
        position: relative;
        transition: 0.1s linear;
        .mask {
          position: absolute;
          z-index: 3;
          background: rgba(255, 255, 255, 0.25);
          left: 0;
          width: 100%;
          height: 100%;
          top: 0;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          cursor: pointer;
        }
        img {
          position: absolute;
          transition: 0.1s linear;
          width: 100%;
          height: 100%;
          // height: 212px;
          // width: 284px;
        }
      }
      .contentWork {
        padding: 0 8px;
        .title:hover {
          color: #d36f16;
        }
        .title {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #3c5065;
          line-height: 20px;
          margin-top: 8px;
        }
        .statistical {
          margin-top: 8px;
          height: 20px;
          line-height: 20px;
          span {
            margin-right: 17px;
          }
          span.typeWork {
            text-align: center;
            width: 34px;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            border-radius: 2px;
            color: #a6b5c1;
            background: #dfe5e9;
          }
          span.browseNumber {
            i {
              font-size: 20px;
              margin-right: 5px;
              color: #9fb0bd;
              float: left;
            }
            em {
              font-size: 12px;
              color: #9fb0bd;
            }
          }
        }
        .authorInfo {
          margin-top: 16px;
          margin-bottom: 16px;
          height: 20px;
          line-height: 20px;
          img {
            border-radius: 50%;
            //   vertical-align: middle;
            float: left;
            margin-right: 8px;
            width: 20px;
            height: 20px;
            border: 0 solid #fbfbfb;
          }
          a:nth-of-type(1):hover {
            color: #d36f16;
          }
          a:nth-of-type(1) {
            display: inline-block;
            width: calc(100% - 28px);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
            color: #304253;
          }
          span:nth-of-type(2) {
            font-size: 12px;
            color: #9fb0bd;
            float: right;
          }
        }
      }
    }
    .advLinkBox {
      max-width: 1380px;
      margin-bottom: 63px;
      margin: 0 auto;
      .advLinkTitle {
        font-size: 18px;
        color: #2d3142;
        font-weight: bold;
        margin-bottom: 23px;
      }
      ul {
        li {
          background: #fff;
          box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
          border-radius: 4px;
          margin-bottom: 17px;
          float: left;
          width: 32.38%;
          margin-right: 1.41%;
          cursor: pointer;
          div {
            border-radius: 4px;
          }
        }
        a {
          width: 100%;
          height: 100%;
        }
        li.noMargin {
          margin-right: 0px;
        }
      }
      .imgWork {
        width: 100%;
        height: 0px;
        padding-bottom: 42.5%;
        transition: 0.1s linear;
        overflow: hidden;
        margin: 0;
        position: relative;
        cursor: pointer;
        img {
          position: absolute;
          transition: 0.1s linear;
          width: 100%;
          height: 100%;
          // height: 212px;
          // width: 284px;
        }
      }
    }
    .designerList {
      max-width: 1380px;
      margin: 0 auto;
      margin-top: 46px;
      margin-bottom: 73px;
      .designerTitle {
        font-size: 32px;
        color: #374567;
        font-weight: bold;
        margin-bottom: 6px;

        text-align: center;
      }
      .borderLineBox {
        text-align: center;
        margin-bottom: 53px;
        height: 4px;
        position: relative;
        .borderLine {
          width: 40px;
          height: 4px;
          display: inline-block;
          background: #3d65f4;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      ul {
        li {
          // background: #fff;
          // box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
          // border-radius: 4px;
          margin-bottom: 15px;
          float: left;
          // width: 13.21%;
          width: 159px;
          height: 159px;
          margin-right: 15px;
          cursor: pointer;
          // div {
          //   border-radius: 4px;
          // }
        }
        a {
          width: 100%;
          height: 100%;
        }
        li.noMargin {
          margin-right: 0px;
        }
      }
      .imgWork {
        width: 100%;
        height: 0px;
        padding-bottom: 100%;
        transition: 0.1s linear;
        overflow: hidden;
        margin: 0;
        position: relative;
        img {
          position: absolute;
          transition: 0.1s linear;
          width: 100%;
          height: 100%;
          // height: 212px;
          // width: 284px;
        }
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .goTop {
    position: fixed;
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;

    color: #fff;
    right: 0px;
    bottom: 56px;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
    border-radius: 2px;
    i {
      font-size: 26px;
      // font-weight: bold;
    }
  }
  .home {
    .homeTopContent {
      margin: 0 auto;
      background: #fff;
      // padding: 0 30px;
      /*	box-shadow: 0 4px 10px 0 rgba(0,0,0,0.09);*/
    }
    .block {
      // margin-top: 5px;
      border-radius: 3px;
      max-width: 1150px;
      margin: 0 auto;
      padding-top: 17px;
      // height: 233px;
      a {
        display: block;
      }
      .imgBannerBox {
        border-radius: 4px;
        width: 100%;
        height: 286px;
        // height: 0px;
        // padding-bottom: 23.33%;
        overflow: hidden;
        transition: 0.1s linear;
        margin: 0;
        // position: relative;
        /*height: 280px;
			background-repeat: no-repeat;
			background-size: 100%;*/
        img {
          // position: absolute;
          // transition: 0.1s linear;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    .advtop {
      // width: 1000px;
      max-width: 1150px;
      margin: 0 auto;
      background: #fff;
      padding-top: 17px;
      // margin-bottom: 25px;
      /*box-shadow: 0 2px 10px 0 rgba(145,145,145,0.10);*/
      ul {
        li {
          float: left;
          width: 383px;
          height: 164px;
          overflow: hidden;

          box-shadow: 0px 7px 12px 0px rgba(145, 141, 192, 0.14),
            0px 2px 8px 0px rgba(145, 145, 145, 0.1);

          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
          }
        }
        a {
          width: 100%;
          height: 100%;
        }
      }
    }
    .nav {
      margin-top: 25px;
      text-align: center;
      ul {
        display: inline-block;
        margin-bottom: -3px;
      }
      .el-menu-item:hover {
        a {
          color: #374567 !important;
          font-weight: bold;
        }
      }
      .el-menu-item {
        padding: 0px;
        margin-right: 64px;
      }
      .el-menu-item:nth-of-type(3) {
        margin-right: 0px;
      }
      .el-menu.el-menu--horizontal {
        border-bottom: 0px;
        .el-menu-item.is-active {
          border-bottom: 3px solid #3d65f4;
          a {
            font-size: 15px;
            color: #374567;
            font-weight: bold;
          }
        }
        .el-menu-item {
          a {
            font-size: 15px;
            // font-weight: bold;
          }
        }
      }

      .el-menu--horizontal > .el-menu-item {
        height: 42px;
        line-height: 42px;
        a {
          color: #9fb0bd;
        }
      }
    }
    .workList {
      max-width: 1150px;
      margin: 0 auto;
      position: relative;

      .pagination {
        margin-top: 15px;
        margin-bottom: 40px;
        text-align: center;
        height: 27px;
        line-height: 27px;
        .totalNumber {
          font-size: 12px;
          color: #999999;
          margin-left: 17px;
          em {
            font-weight: bold;
            color: #202020;
            margin-left: 3px;
            margin-right: 3px;
          }
        }
      }
      ul {
        padding-top: 24px;

        li {
          background: #fff;

          box-shadow: 0px 2px 8px 0px rgba(145, 145, 145, 0.1);

          border-radius: 3px;
          margin-bottom: 18px;
          float: left;
          width: 215px;
          margin-right: 18px;
          cursor: pointer;
          div {
            border-top-left-radius: 3px;
            border-top-right-radius: 3px;
          }
          a {
            display: inline-block;
            width: 100%;
            height: 100%;
          }
        }

        li.noMargin {
          margin-right: 0px;
        }
      }
      .imgWork {
        width: 100%;
        height: 0px;
        padding-bottom: 75%;
        overflow: hidden;
        margin: 0;
        position: relative;
        transition: 0.1s linear;
        .mask {
          position: absolute;
          z-index: 3;
          background: rgba(255, 255, 255, 0.25);
          left: 0;
          top: 0;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
        img {
          position: absolute;
          transition: 0.1s linear;
          width: 100%;
          height: 100%;
          // height: 212px;
          // width: 284px;
        }
      }
      .contentWork {
        padding: 0 6px;
        height: 88.96px;
        .title:hover {
          color: #d36f16;
        }
        .title {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 12px;
          display: block;
          height: 17px;
          line-height: 17px;
          color: #3c5065;
          margin-top: 7px;
          width: 100%;
        }
        .statistical {
          margin-top: 7px;
          height: 17px;
          line-height: 17px;
          span {
            margin-right: 15px;
          }
          span.typeWork {
            width: 28px;
            height: 17px;
            line-height: 17px;
            font-size: 10px;
            background: #dfe5e9;
            border-radius: 2px;
            text-align: center;
            // padding-left: 5px;
            // padding-right: 5px;
            // height: 20px;

            color: #a6b5c1;
            em {
              font-size: 10px;
            }
          }
          span.browseNumber {
            i {
              font-size: 16px;
              margin-right: 3px;
              color: #9fb0bd;
              float: left;
            }
            em {
              font-size: 10px;
              color: #9fb0bd;
            }
          }
        }
        .authorInfo {
          margin-top: 13px;
          margin-bottom: 13px;
          height: 17px;
          line-height: 17px;
          img {
            border-radius: 50%;
            //   vertical-align: middle;
            float: left;
            margin-right: 7px;
            width: 17px;
            height: 17px;
            border: 0 solid #fbfbfb;
          }
          a:nth-of-type(1):hover {
            color: #d36f16;
          }
          a:nth-of-type(1) {
            display: inline-block;
            width: calc(100% - 24px);
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 12px;
            color: #304253;
          }
          span:nth-of-type(2) {
            font-size: 10px;
            color: #9fb0bd;
            float: right;
          }
        }
      }
    }
    .advLinkBox {
      max-width: 1150px;
      margin-bottom: 63px;
      margin: 0 auto;
      .advLinkTitle {
        font-size: 15px;
        color: #2d3142;
        font-weight: bold;
        margin-bottom: 20px;
      }
      ul {
        li {
          background: #fff;
          box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
          border-radius: 5px;
          margin-bottom: 14px;
          float: left;
          width: 374px;
          height: 164px;
          margin-right: 13px;
          cursor: pointer;
          div {
            border-radius: 5px;
          }
        }
        a {
          width: 100%;
          height: 100%;
        }
        li.noMargin {
          margin-right: 0px;
        }
      }
      .imgWork {
        width: 100%;
        height: 100%;

        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          // height: 212px;
          // width: 284px;
        }
      }
    }
    .designerList {
      max-width: 1150px;
      margin: 0 auto;
      margin-top: 39px;
      margin-bottom: 48px;
      .designerTitle {
        font-size: 27px;
        color: #374567;
        // font-weight: bold;
        margin-bottom: 5px;

        font-family: PingFangSC-Semibold, PingFang SC;

        text-align: center;
      }
      .borderLineBox {
        text-align: center;
        margin-bottom: 44px;
        height: 3px;
        position: relative;
        .borderLine {
          width: 33px;
          height: 3px;
          display: inline-block;
          background: #3d65f4;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      ul {
        li {
          // background: #fff;
          // box-shadow: 0 2px 10px 0 rgba(145, 145, 145, 0.1);
          // border-radius: 4px;
          margin-bottom: 13px;
          float: left;
          width: 133px;
          height: 133px;
          margin-right: 12px;
          cursor: pointer;
          // div {
          //   border-radius: 4px;
          // }
        }
        a {
          width: 100%;
          height: 100%;
        }
        li.noMargin {
          margin-right: 0px;
        }
      }
      .imgWork {
        width: 100%;
        height: 100%;

        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          // height: 212px;
          // width: 284px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue